import React, { useMemo, useState } from 'react';
import { PagesCommonProps } from '../helpers/pagesUtil';
import AdminsAppHeader from '../components/AdminsAppHeader';
import PageAdminDashboardGraphs from './AdminDashboardGraphs';
import ManagerDashboardGraphs from './ManagerDashboardGraphs';
import { pageFilterOptionsDefaultState } from '../consts/graphs';
import { useDashboardViews } from '../hooks/useDashboardViews';
import { ADMIN_APP_TYPES, adminAppsTypesType } from '../consts/shared';

type AdminAppProps = {
  organisationId?: string,
  adminType?: adminAppsTypesType,
};

const AdminApp: React.FC<AdminAppProps> = ({ organisationId, adminType = ADMIN_APP_TYPES.ADMIN }) => {
  const { dashboardViews, loading } = useDashboardViews(false, true);

  const [filters, setFilters] = useState<PagesCommonProps["filters"]>({
    organisationId,
    ...pageFilterOptionsDefaultState,
  });

  const currentDashboard = useMemo(() => {
    if (dashboardViews.length === 0) return undefined;
    if (adminType === ADMIN_APP_TYPES.ADMIN) {
      return dashboardViews.find((dashboard) => dashboard.name.includes('Admin') || dashboard.id === 7);
    }
    return dashboardViews.find((dashboard) => dashboard.name.includes('Manager') || dashboard.id === 8);
  }, [dashboardViews, adminType]);

  const dashboardLabel = adminType === ADMIN_APP_TYPES.ADMIN ? 'Admin' : 'Manager';

  return (
    <>
      <div className="pdf-export-target">
        <AdminsAppHeader
          filters={filters}
          setFilters={setFilters}
          adminType={adminType}
          currentDashboard={currentDashboard}
        />
        <div className="app">
          <div className="dashboard-container">
            {!loading && !currentDashboard ? (
              <div className="dashboard-disabled-message">
                <h2>{dashboardLabel} dashboard is currently disabled</h2>
                <p>Please contact your administrator if you need access.</p>
              </div>
            ) : adminType === ADMIN_APP_TYPES.ADMIN ? (
              <PageAdminDashboardGraphs
                filters={filters}
                setFilters={setFilters}
                graphs={currentDashboard?.graphs || []}
              />
            ) : (
              <ManagerDashboardGraphs
                filters={filters}
                setFilters={setFilters}
                graphs={currentDashboard?.graphs || []}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminApp;
